module.exports = __webpack_public_path__ + "static/media/64.4f10086a.jpg";